import React from 'react';
import S from './InputCheckbok.styled';
import Icon from '../Icon';
import { FieldError } from 'react-hook-form';

export interface IInputCheckboxProps {
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  checked?: boolean;
  disabled?: boolean;
  register?: any;
  error?: FieldError | undefined;
  color?: string;
  orange?: boolean;
  id?: string;
}

const InputCheckbox: React.FC<IInputCheckboxProps> = ({
  onChange,
  checked,
  disabled,
  register,
  error,
  color,
  orange,
  id,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) onChange(e);
  };

  return (
    <S.CheckboxWrapper $orange={orange}>
      <S.Input
        type="checkbox"
        tabIndex={0}
        checked={checked}
        onChange={!disabled && handleChange}
        onClick={onChange}
        disabled={disabled}
        {...register}
        $error={error}
        $color={color}
        $orange={orange}
        id={id}
      />
      <Icon src={'CheckmarkForms'} color={'white'} />
    </S.CheckboxWrapper>
  );
};

export default InputCheckbox;
